import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { UserService } from '@user/user.service';
import { map, take, switchMap, tap } from 'rxjs/operators';
import { ROLE_TYPE } from '@user/role-type';
import { ProgramService } from '@program/shared/program.service';
import { Program, ProgramSubmissionType } from '@program/shared/program.model';
import { Observable, of } from 'rxjs';

/*
* Does not allow to access SCC if user does not contain Developer Credit role.
* */
@Injectable({ providedIn: 'root' })
export class SccGuard implements CanActivate {
  private program: Program;

  constructor(
    private _userService: UserService,
    private _router: Router,
    private _programService: ProgramService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return this._userService.getCurrentUser().pipe(
      switchMap(user => {
        if (user.hasRole(ROLE_TYPE.ORGANIZATION_ADMIN) && user?.organization?.credit && user?.organization?.approvedCredit) {
          return of(true);
        }

        if (!user.hasRole(ROLE_TYPE.DEVELOPER_CREDIT)) {
          this._router.navigate(['/oes/home']);
          return of(false);
        }

        if (this.program) {
          return of(true);
        }

        return this.loadInvitedPrograms();
      })
    );
  }

  private loadInvitedPrograms(): Observable<boolean> {
    const params = { params: { page: 0, size: 1000, submissionTypes: [ProgramSubmissionType.SCC] } };
    return this._programService.getPrograms(params)
      .pipe(
        take(1),
        map((programs: Program[]) => {
          this.program = programs.length ? programs[0] : null;
          if (this.program) {
            return true;
          } else {
            window.location.href = 'https://procure.odyssey.energy/';
            return false;
          }
        })
      );
  }
}
